<template>
  <div class="top-header-container" :class="{'top-header-container-remove-radius' : contentPosition === -250}">
    <div class="mobile-header-icon" v-if="$store.state.appConfig.windowWidth < 769">
      <MobileHeaderIcon />
    </div>
    
    <BackButton :clickMethod="back" class="mb-3"/>

    <h4>
      {{ $tI('Ancient Origins Breakdown') }}
      <span @click="originBreakdownInfoModal.showModal = true" class="open-info-modal-btn"
        v-click-track="'Iframe.ancientDnaAncientOriginsBreakdownReportTooltipClicked'">
        <InfoIcon />
      </span>
    </h4>

    <p class="description" v-html="tailorModalDesc">
    </p>
    <p class="description" v-html="tailorModal" @click="handleLinkClick">
    </p>
    <hr/>

    <PeriodicalPeriods class="mt-3 mb-4"/>

    <OriginBreakdownInfoModal v-if="originBreakdownInfoModal.showModal" :modalObject="originBreakdownInfoModal"/>
    <SelectRegionModal v-if="selectRegionModal.showModal" :modalObject="selectRegionModal" />
  </div>
</template>

<script>
import MobileHeaderIcon from '@/components/icons/MobileHeaderIcon.vue';
import BackButton from '@/components/ui/BackButton.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import OriginBreakdownInfoModal from './modals/OriginBreakdownInfoModal.vue';
import SelectRegionModal from './modals/SelectRegionModal.vue'
import PeriodicalPeriods from './details/PeriodicalPeriods.vue';

export default {
  components: {
    MobileHeaderIcon,
    BackButton,
    InfoIcon,
    OriginBreakdownInfoModal,
    SelectRegionModal,
    PeriodicalPeriods,
  },
  props: {
    contentPosition: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      originBreakdownInfoModal: {
        showModal: false,
      },
      selectRegionModal: {
        showModal: false,
      },
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'dashboard' });
    },
    decodeEntities(html) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = html;
      return textarea.value;
    },
    handleLinkClick(event) {
      if (event.target.classList.contains('open-select-region')) {
        this.selectRegionModal.showModal = true;
      }
    }
  },
  computed: {
    selectedRegionName() {
      const selectedRegion = this.$store.getters['region/getSelectedRegion']
      return selectedRegion ? selectedRegion.regionName : '';
    }, 
    tailorModal() {
      let str = '';
      if (this.selectedRegionName === 'Global') {
        str = this.$tI_YO_G('Ancient Origins Subtitle Tailor the model Global');
      } else {
        str = this.$tI_YO_G('Ancient Origins Subtitle Tailor the model Specific origin');
      }

      const decodedStr = this.decodeEntities(str);
      
      const lastStr = decodedStr.replace(
        /\[link title="([^"]+)"\]/g,
        `<a class="open-select-region">$1</a>`
      );
      
      return lastStr
    },

    tailorModalDesc() {
      let str = '';
      if (this.selectedRegionName === 'Global') {
        str = this.$tI_G('Ancient Origins Subtitle Global');
      } else {
        str = this.$tI_G('Ancient Origins Subtitle Specific origin');
      }

      const lastStr = str.replace('{represented_origin}', this.$t(this.selectedRegionName));
      
      return lastStr
    },
  },
};
</script>

<style lang="scss" scoped>
.top-header-container {
  padding: 28px;
  background-color: var(--white-100);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.top-header-container-remove-radius {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

</style>

<style lang="scss">
.open-select-region {
  color: var(--mh-btn-color);
  cursor: pointer;
}
</style>
